import script from "./UserDetailOld.vue?vue&type=script&setup=true&lang=js"
export * from "./UserDetailOld.vue?vue&type=script&setup=true&lang=js"

import "./UserDetailOld.vue?vue&type=style&index=0&id=0204339a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0204339a"]])

export default __exports__